import { AGENT_LABELS, type AgentName } from '../../types/agent';

type T = (key: string, opts?: Record<string, unknown>) => string;

/** Human label of an agent (§11.5): translated for the known agents, the raw name otherwise
 *  (e.g. a test `echo` agent). */
export function agentLabel(agent: string, t: T): string {
  const key = (AGENT_LABELS as Record<string, string>)[agent as AgentName];
  return key ? t(key) : agent;
}

/** Small mono tag naming a sub-agent (action cards, history rows). */
export function AgentTag({ agent, t }: { agent: string; t: T }) {
  return <span className="shrink-0 rounded-sm bg-accent-bg px-1.5 py-px font-mono text-[10.5px] text-accent-dark">{agentLabel(agent, t)}</span>;
}
